<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info-coop-card mypage-title-icon"
            >
            <div class="col-sm-12 col-notMx">
                <div class="messageBox" v-if="this.all_card_nos.length">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col" class="golfCourse">ゴルフ場</th>
                                <th class="cardNo text-right text-sm-left" scope="col">カード番号</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="data in all_card_nos" :key="data.id">
                                <td class="text-break">{{ data.golf_name }}</td>
                                <td class="text-break text-right text-sm-left">{{ data.card_no }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm">
                            <li class="page-item" @click="ClickPagination('Limited', 'Previous')">
                                <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                            </li>
                            <li class="pagination-center">
                                <span>{{ display_pagination }} / {{ max_pagination }}</span>
                            </li>
                            <li class="page-item" @click="ClickPagination('Limited', 'Next')">
                                <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="messageBox text-body text-center mb-3" v-else>連携されたカード番号がありません。</div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import {
    GET_MEMBER_CARD_LIST
} from '../../constants/mypage_card_no';
import MypageSideMenu from './MypageSideMenu';
import MypageHeader from './MypageHeader';
import Card from '../components/Card';
import { memberStatusMixin } from './memberStatusMixin';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        Card
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            page_title: '連携カード番号参照',
            display_limit_rows: 5,
            display_begin_row: 0,
            member_no: '',
            full_name: '',
            golf_group_code: process.env.MIX_GROUP_CODE,
            all_card_nos: [],
            display_card_nos: [],
            max_pagination: 1,
            display_pagination: 1
        };
    },
    created () {
        this.initialize();
    },
    watch: {
        display_pagination: function (now) {
            this.display_card_nos = [];
            const nextNum = now * this.display_limit_rows;
            for (var i = nextNum - this.display_limit_rows; i < nextNum; i++) {
                if (this.all_card_nos[i] !== undefined) {
                    this.display_card_nos.push(this.all_card_nos[i])
                }
            }
        },
    },
    computed: {
        paginationDisabled () {
            return this.max_pagination === 1 || this.max_pagination === 0;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit("loading/setIsLoading", true);
            this.GetLoginUserMemberStatus();
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name = this.$store.state.auth.loginMember.family_name
                            + ' '
                            + this.$store.state.auth.loginMember.given_name;
            await this.getCardNoList();
            this.$store.commit("loading/setIsLoading", false);
        },
        getCardNoList: function () {
            this.all_card_nos = [];
            this.$apollo.mutate({
                mutation: GET_MEMBER_CARD_LIST,
                variables: {
                    member_no: this.$store.state.auth.loginMember.member_no,
                    golf_group_code: this.golf_group_code,
                    begin_row: this.display_begin_row,
                    limit_rows: this.display_limit_rows
                }
            }).then(res => {
                this.all_card_nos = res.data.getMemberCardListMember.MemberCardList;
                if (this.all_card_nos) {
                    // 期間期限ポイントの最大ページネーション数
                    this.max_pagination = Math.ceil(res.data.getMemberCardListMember.count / this.display_limit_rows);
                }
            })
        },
        ClickPagination: function (target, mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.display_pagination > 1) {
                    this.display_pagination--;
                    if (this.display_pagination === 1) {
                        this.display_begin_row = 0;
                    } else {
                        this.display_begin_row = this.display_begin_row - this.display_limit_rows;
                    }
                    this.getCardNoList();
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.display_pagination < this.max_pagination) {
                    this.display_begin_row = this.display_begin_row + this.display_limit_rows;
                    this.display_pagination++;
                    this.getCardNoList();
                } else {
                    return;
                }
            }
        }
    }
}

</script>

<style scoped>

.golfCourse{
    width: 55%;
}

.cardNo{
    width: 45%;
}
</style>
